<template>
  <vx-card>
    <vs-row vs-w="12">
      <vs-col vs-sm="12" vs-lg="6" class="mb-4">
        <vx-card>
          <h6 class="mb-4">Atualizar Status da Proposta/Cotação</h6>
          <ValidationObserver v-slot="{ validated, invalid }">
            <form role="form" @submit.stop.prevent="updateProposalStatus">
              <vs-row vs-w="12">
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors, touched }">
                    <span>Código da Cotação</span>
                    <vs-input
                      class="w-full"
                      name="proposalId"
                      id="proposalId"
                      v-model="proposalStatusForm.proposalId"
                      :danger="errors.length > 0"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                    />
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Status</span>
                    <v-select
                      :options="proposalStatusOptions"
                      name="proposalStatus"
                      id="proposalStatus"
                      v-model="proposalStatusForm.status"
                      :class="errors.length > 0 ? 'danger' : ''"
                    ></v-select>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
                  <vs-button :disabled="!validated || invalid" class="my-5">Atualizar</vs-button>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-col>
      <vs-col vs-sm="12" vs-lg="6" class="mb-4">
        <vx-card>
          <h6 class="mb-4">Atualizar Status da Apólice</h6>
          <ValidationObserver v-slot="{ validated, invalid }">
            <form role="form" @submit.stop.prevent="updatePolicyStatus">
              <vs-row vs-w="12">
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Código da Apólice</span>
                    <vs-input
                      class="w-full"
                      name="policyId"
                      id="policyId"
                      v-model="policyStatusForm.policyId"
                      :danger="errors.length > 0"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                    />
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Status</span>
                    <v-select
                      :options="policyStatusOptions"
                      name="policyStatus"
                      id="policyStatus"
                      v-model="policyStatusForm.status"
                      :class="errors.length > 0 ? 'danger' : ''"
                    ></v-select>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
                  <vs-button :disabled="!validated || invalid" class="my-5">Atualizar</vs-button>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-col>
    </vs-row>
    <vs-row vs-w="12">
      <vs-col vs-sm="12" vs-lg="6" class="mb-4">
        <vx-card>
          <h6 class="mb-4">Atualizar Status do Segurado</h6>
          <ValidationObserver v-slot="{ validated, invalid }">
            <form role="form" @submit.stop.prevent="updateInsuredStatus">
              <vs-row vs-w="12">
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Código do Segurado</span>
                    <vs-input
                      class="w-full"
                      name="insuredId"
                      id="insuredId"
                      v-model="insuredStatusForm.insuredId"
                      :danger="errors.length > 0"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                    />
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Status</span>
                    <v-select
                      :options="insuredStatusOptions"
                      name="insuredStatus"
                      id="insuredStatus"
                      v-model="insuredStatusForm.status"
                      :class="errors.length > 0 ? 'danger' : ''"
                    ></v-select>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
                  <vs-button :disabled="!validated || invalid" class="my-5">Atualizar</vs-button>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-col>
      <vs-col vs-sm="12" vs-lg="6" class="mb-4">
        <vx-card>
          <h6 class="mb-4">Atualizar Status da Placa</h6>
          <ValidationObserver v-slot="{ validated, invalid }">
            <form role="form" @submit.stop.prevent="updatePlateStatus">
              <vs-row vs-w="12">
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Placa</span>
                    <vs-input
                      v-mask="'AAA-#XX#'"
                      class="w-full"
                      name="plate"
                      id="plate"
                      v-model="plateStatusForm.plate"
                      :danger="errors.length > 0"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                    />
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <span>Status</span>
                    <v-select
                      :options="actionOptions"
                      name="status"
                      id="status"
                      v-model="plateStatusForm.status"
                      :class="errors.length > 0 ? 'danger' : ''"
                    ></v-select>
                  </ValidationProvider>
                </vs-col>
                <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
                  <vs-button :disabled="!validated || invalid" class="my-5">Atualizar</vs-button>
                </vs-col>
              </vs-row>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-col>
    </vs-row>
  </vx-card>
</template>
<script>
import updateStatusApi, {endpoints} from "../../../services/update.status.api";
import vSelect from 'vue-select';
import {ValidationProvider, ValidationObserver} from "vee-validate";
import { INSURED_STATUS } from "../../../constants/insuredStatus";

export default {
  name: "AlteracaoDeStatus",
  data() {
    return {
      proposalStatusForm: {
        proposalId: null,
        status: null
      },
      plateStatusForm: {
        plate: null,
        status: null
      },
      insuredStatusForm: {
        insuredId: null,
        status: null
      },
      policyStatusForm: {
        policyId: null,
        status: null
      },
      policyStatusOptions: [],
      insuredStatusOptions: INSURED_STATUS,
      proposalStatusOptions: [],
      actionOptions: [
        {
          label: "Ativo",
          value: "ATIVO",
        },
        {
          label: "Inativo",
          value: "INATIVO",
        }
      ],
    }
  },
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver
  },
  mounted() {
    this.getProposalStatusOptions();
    this.getPolicyStatusOptions();
  },
  methods: {
    updateProposalStatus() {
      this.$vs.loading();
      const payload = {
        id: parseInt(this.proposalStatusForm.proposalId),
        status: this.proposalStatusForm.status.value
      }
      updateStatusApi.update(endpoints.PROPOSAL, payload).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Status atualizado com sucesso',
          color: 'success'
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      }).finally(
        () => {
          this.proposalStatusForm.proposalId = null;
          this.proposalStatusForm.status = null;
        }
      )
    },
    updatePlateStatus() {
      this.$vs.loading();
      const payload = {
        plate: this.plateStatusForm.plate,
        status: this.plateStatusForm.status.value
      }
      updateStatusApi.update(endpoints.PLATE, payload).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Status atualizado com sucesso',
          color: 'success'
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      }).finally(
        () => {
          this.plateStatusForm.plate = null;
          this.plateStatusForm.status = null;
        }
      )
    },
    updatePolicyStatus() {
      this.$vs.loading();
      const payload = {
        id: parseInt(this.policyStatusForm.policyId),
        status: this.policyStatusForm.status.value
      }
      updateStatusApi.update(endpoints.POLICY, payload).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Status atualizado com sucesso',
          color: 'success'
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      }).finally(
        () => {
          this.policyStatusForm.proposalId = null;
          this.policyStatusForm.status = null;
        }
      )
    },
    updateInsuredStatus() {
      this.$vs.loading();
      const payload = {
        id: parseInt(this.insuredStatusForm.insuredId),
        status: this.insuredStatusForm.status.value
      }
      updateStatusApi.update(endpoints.INSURED, payload).then(() => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Status atualizado com sucesso',
          color: 'success'
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      })
    },
    getProposalStatusOptions() {
      this.$vs.loading();
      updateStatusApi.getOptions(endpoints.PROPOSAL).then(response => {
        this.$vs.loading.close();
        this.proposalStatusOptions = response.map(option => {
          return {
            label: option.statusName,
            value: option.id
          }
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      }).finally(
        () => {
          this.insuredStatusForm.proposalId = null;
          this.insuredStatusForm.status = null;
        }
      )
    },
    getPolicyStatusOptions() {
      this.$vs.loading();
      updateStatusApi.getOptions(endpoints.POLICY).then(response => {
        this.$vs.loading.close();
        this.policyStatusOptions = response.map(option => {
          return {
            label: option.status,
            value: option.id
          }
        })
      }).catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error,
          color: 'danger'
        })
      })
    },
  },
}
</script>
<style lang="scss">

</style>
